module.exports = {
	"_args": [
		[
			{
				"raw": "web3",
				"scope": null,
				"escapedName": "web3",
				"name": "web3",
				"rawSpec": "",
				"spec": "latest",
				"type": "tag"
			},
			"/saveproj/koshima/oyomecoin/oyomecoin"
		]
	],
	"_cnpm_publish_time": 1521490978795,
	"_from": "web3@latest",
	"_hasShrinkwrap": false,
	"_id": "web3@1.0.0-beta.33",
	"_inCache": true,
	"_location": "/web3",
	"_nodeVersion": "6.11.4",
	"_npmOperationalInternal": {
		"host": "s3://npm-registry-packages",
		"tmp": "tmp/web3_1.0.0-beta.33_1521490978723_0.5557657931402076"
	},
	"_npmUser": {
		"name": "frozeman",
		"email": "fabian@frozeman.de"
	},
	"_npmVersion": "3.10.10",
	"_phantomChildren": {},
	"_requested": {
		"raw": "web3",
		"scope": null,
		"escapedName": "web3",
		"name": "web3",
		"rawSpec": "",
		"spec": "latest",
		"type": "tag"
	},
	"_requiredBy": [
		"#USER",
		"/"
	],
	"_resolved": "http://registry.npm.taobao.org/web3/download/web3-1.0.0-beta.33.tgz",
	"_shasum": "c6021b5769927726371c184b868445311b139295",
	"_shrinkwrap": null,
	"_spec": "web3",
	"_where": "/saveproj/koshima/oyomecoin/oyomecoin",
	"author": {
		"name": "ethereum.org"
	},
	"authors": [
		{
			"name": "Fabian Vogelsteller",
			"email": "fabian@ethereum.org",
			"homepage": "http://frozeman.de"
		},
		{
			"name": "Marek Kotewicz",
			"email": "marek@parity.io",
			"url": "https://github.com/debris"
		},
		{
			"name": "Marian Oancea",
			"url": "https://github.com/cubedro"
		},
		{
			"name": "Gav Wood",
			"email": "g@parity.io",
			"homepage": "http://gavwood.com"
		},
		{
			"name": "Jeffery Wilcke",
			"email": "jeffrey.wilcke@ethereum.org",
			"url": "https://github.com/obscuren"
		}
	],
	"bugs": {
		"url": "https://github.com/ethereum/web3.js/issues"
	},
	"dependencies": {
		"web3-bzz": "1.0.0-beta.33",
		"web3-core": "1.0.0-beta.33",
		"web3-eth": "1.0.0-beta.33",
		"web3-eth-personal": "1.0.0-beta.33",
		"web3-net": "1.0.0-beta.33",
		"web3-shh": "1.0.0-beta.33",
		"web3-utils": "1.0.0-beta.33"
	},
	"description": "Ethereum JavaScript API",
	"devDependencies": {},
	"directories": {},
	"dist": {
		"shasum": "c6021b5769927726371c184b868445311b139295",
		"size": 5605,
		"noattachment": false,
		"tarball": "http://registry.npm.taobao.org/web3/download/web3-1.0.0-beta.33.tgz"
	},
	"keywords": [
		"Ethereum",
		"JavaScript",
		"API"
	],
	"license": "LGPL-3.0",
	"main": "src/index.js",
	"maintainers": [
		{
			"name": "frozeman",
			"email": "fabian@frozeman.de"
		}
	],
	"name": "web3",
	"namespace": "ethereum",
	"optionalDependencies": {},
	"publish_time": 1521490978795,
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "https://github.com/ethereum/web3.js/tree/master/packages/web3"
	},
	"scripts": {},
	"types": "index.d.ts",
	"version": "1.0.0-beta.33"
};


//////////////////
// WEBPACK FOOTER
// ./~/web3/package.json
// module id = 588
// module chunks = 0